import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiBusinessBaseStatistics } from '../../../../api/business_base/ApiBusinessBaseStatistics';
import {
  DateRangeFilter,
  ResultsCountFilter,
  TypesFilter,
  ValueFilter,
} from '../../../hexa_api/statistics/StatisticsFilters';
import StatisticsRankedList from '../../../hexa_api/statistics/StatisticsRankedList';
import StatisticsSection from '../../../hexa_api/statistics/StatisticsSection';
import { useMostSearchedStats } from '../../../hexa_api/statistics/useMostSearchedStats';

interface MostSearchedTabProps {
  onFetchError: (message: string) => void;
}

const MostSearchedTab = ({ onFetchError }: MostSearchedTabProps) => {
  const { t } = useTranslation();

  const fetchMostSearched = useCallback(
    (params: Parameters<typeof ApiBusinessBaseStatistics.mostSearched>[0]) =>
      ApiBusinessBaseStatistics.mostSearched(params).then(
        (response) => response.most_searched
      ),
    []
  );

  const mostSearchedStats = useMostSearchedStats(
    fetchMostSearched,
    onFetchError
  );

  return (
    <StatisticsSection
      title={t('business_base_statistics.most_searched_title')}
      subtitle={t('business_base_statistics.most_searched_subtitle')}
      icon={<LeaderboardOutlinedIcon />}
      filtersTitle={t('entity_statistics.filters')}
      onResetFilters={mostSearchedStats.resetFilters}
      isLoading={mostSearchedStats.isLoading}
      loadingText={t('business_base_statistics.most_searched_loading')}
      isEmpty={mostSearchedStats.results.length === 0}
      emptyText={t('business_base_statistics.most_searched_empty')}
      filters={
        <>
          <DateRangeFilter state={mostSearchedStats} />
          <ResultsCountFilter state={mostSearchedStats} />
          <ValueFilter
            state={mostSearchedStats}
            label={t('business_base_statistics.value_filter_label')}
            placeholder={t('business_base_statistics.value_filter_placeholder')}
          />
          <TypesFilter state={mostSearchedStats} />
        </>
      }
    >
      <StatisticsRankedList
        valueLabel={t('entity_statistics.search_count')}
        showTagTooltips={false}
        entries={mostSearchedStats.results.map((entry, index) => ({
          id: `${entry.type}-${entry.value}-${index}`,
          label: entry.value,
          tags: [entry.type.toUpperCase()],
          value: entry.searched_count,
        }))}
      />
    </StatisticsSection>
  );
};

export default MostSearchedTab;
